/* 格式化date对象 */
const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

export function switchTitle(name) {
    switch (name) {
        case '111':
            return '药学管理与法规';
        case '112':
            return '药学专业知识（一）';
        case '113':
            return '药学专业知识（二）';
        case '114':
            return '药学综合知识与技能';
        case '115':
            return '中药学专业知识（一）';
        case '116':
            return '中药学专业知识（二）';
        case '117':
            return '中药学综合知识与技能';
        case '103':
            return '中学 教育知识与能力';
        case '102':
            return '小学 教育教学知识与能力';
        case '104':
            return '幼儿 保教知识与能力';
        case '99':
            return '幼儿 综合素质';
        case '101':
            return '小学 综合素质';
        case '100':
            return '中学 综合素质';
    }
}

export function formatTimeNum(date, must) {
    if (!date) return;
    if (typeof date == 'number' || typeof date == 'object') {
        date = new Date(date);
    } else {
        let startIndex = date.indexOf('.') >= 0 ? date.indexOf('.') : -1;
        if (startIndex >= 0) date = date.substr(0, startIndex);
        date = date.replace(/-/g, "/");
        date = new Date(date);
    }
    let value = {};
    value.year = date.getFullYear();
    value.month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    value.day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    value.hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    value.minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    value.second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
    return value;
}

/* 格式化时间为指定格式 */
export function formatDate(date, format = 'YY-MM-DD h:m:s') {
    if (!date) return;
    let value = formatTimeNum(date);
    let dateStr = '';
    switch (format) {
        case 'YY-MM-DD h:m:s':
            dateStr = `${value.year}-${value.month}-${value.day} ${value.hour}:${value.minute}:${value.second}`;
            break;
        case 'MM-DD':
            dateStr = `${value.month}-${value.day}`;
            break;
        case 'MM-DD h:m':
            dateStr = `${value.month}-${value.day} ${value.hour}:${value.minute}`;
            break;
        case 'DD':
            dateStr = `${value.day}`;
            break;
        case 'h:m':
            dateStr = `${value.hour}:${value.minute}`;
            break;
        case 'h':
            dateStr = `${value.hour}`;
            break;
        case 'm':
            dateStr = `${value.minute}`;
            break;
        case 'YY-MM-DD h:m':
            dateStr = `${value.year}-${value.month}-${value.day} ${value.hour}:${value.minute}`;
            break;
        default:
            dateStr = `${value.year}-${value.month}-${value.day} ${value.hour}:${value.minute}:${value.second}`;
            break;
    }
    return dateStr
}

const getParamsFromStr = url => {
    let tmp_url = url.replace(/#.*/, '').replace(/.*\?/, '');
    let arr = tmp_url.split('&');
    let obj = {};
    _.each(arr, item => {
        obj[item.split('=')[0]] = decodeURIComponent(item.split('=')[1]);
    });
    return obj;
}
const filterTextByObj = obj => {
        if (!obj) return obj;
        let temp = '';
        Object.keys(obj).forEach(key => {
            temp += `${key}=${obj[key]}&`;
        })
        return temp.substr(0, temp.length - 1);
    }
    //  秒数格式化
export const formatSeconds = second => {
        let s = parseInt(second % 3600 % 60);
        s = s < 10 ? `0${s}` : s;
        let m = parseInt(second % 3600 / 60);
        m = m < 10 ? `0${m}` : m;
        let h = parseInt(second / 3600 % 24);
        h = h < 10 ? `0${h}` : h;
        let d = parseInt(second / 86400);
        if (second < 3600) {
            return `${m}:${s}`;
        } else {
            return `${d}天 ${h}小时 ${m}分钟 ${s}秒`;
        }
    }
    //  检验手机号码格式
const validateMobile = value => {
    console.log(value);
    if (value.length < 11) return false;
    let reg = /^1[3|4|5|7|8|9][0-9]\d{4,8}$/;
    // console.log()
    return reg.test(value);
}
export const setTitle = (title) => {
        document.title = title
        let iframe = document.createElement("iframe");
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.onload = function(e) {
            document.body.removeChild(iframe)
        }
    }
    // 过滤字符串
export const formatDatatoWxml = val => {
    if (!val) return null;
    val = val.replace(/<br\s?\/?>/ig, "\ \n");
    let split = val.split(/(<.+?>)/ig);
    let reg = new RegExp("<img.+?src=['\"](\\S+)['\"].+?>", ''),
        reg2 = new RegExp('\\\\n', 'ig'),
        inlabel = false,
        result = new Array,
        tmp = '',
        cls = '';
    for (var i in split) {
        let k = split[i];
        if (!k) continue;
        if (k[0] === '<' && k[k.length - 1] === '>') {
            let t = reg.exec(k);
            if (t) {
                let style = '';
                let rule = '';
                if (t[0].indexOf('style') > -1) {
                    // .replace(/\s?style="[^>]+?"/ig,'')
                    style = k.match(/style=\"(.*)\"/gi)[0];
                    rule = {
                        'src': t[1],
                        'type': 'image',
                        'style': style.substr(7, style.length - 2)
                    };
                } else {
                    style = k.match(/style=\"(.*)\"/gi);
                    rule = {
                        'src': t[1],
                        'type': 'image'
                    }
                }
                result.push(rule);
            } else {
                if (k[1] === '/') {
                    inlabel = false;
                    tmp = tmp.replace(reg2, '');
                    tmp = tmp.replace(/&nbsp;?/ig, '\t')
                    result.push({
                        'content': tmp,
                        'class': cls,
                        'type': 'text'
                    });
                } else {
                    tmp = '';
                    cls = k.substring(1, k.length - 1);
                    inlabel = true;
                }
            }
        } else {
            if (inlabel) {
                tmp = k;
            } else {
                k = k.replace(reg2, '');
                k = k.replace(/&nbsp;?/ig, '\t');
                result.push({
                    'content': k,
                    'class': 'text'
                });
            }
        }
    }
    return result;
}
export function autoPlayVideo(video) {

    if (window.WeixinJSBridge) {
        WeixinJSBridge.invoke('getNetworkType', {}, function(e) {
            video.play();
        }, false);
    } else {
        document.addEventListener("WeixinJSBridgeReady", function() {
            WeixinJSBridge.invoke('getNetworkType', {}, function(e) {
                video.play();
            });
        }, false);
    }
    video.play();

    return false;
}
export function findBrothersComponents(context, componentName, exceptMe = true) {
    let res = context.$parent.$children.filter(item => {
        console.log(item.$options.name)
        return item.$options.name === componentName;
    });
    if (exceptMe) {
        let index = res.findIndex(item => item._uid === context._uid);
        res.splice(index, 1);
    }
    return res;
}
// 各种格式转换
export function format(fmt, timeStamp) {
    var date = new Date(timeStamp * 1000)
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return fmt
}

export const nurseSubjectItemList = [{
    subjectId: 1,
    list: [{
        id: 5525,
        name: '专业实务'
    }, {
        id: 5526,
        name: '实践能力'
    }]
}, {
    subjectId: 2,
    list: [{
        id: 5510,
        name: '基础护理学'
    }, {
        id: 5509,
        name: '儿科'
    }, {
        id: 5508,
        name: '妇科'
    }, {
        id: 5507,
        name: '外科'
    }, {
        id: 5506,
        name: '内科'
    }]
},  {
    subjectId: 3,
    list: [{
        id: 5566,
        name: '考前综合训练'
    }, {
        id: 5505,
        name: '相关专业知识'
    }, {
        id: 5504,
        name: '社区'
    }, {
        id: 5503,
        name: '儿科'
    }, {
        id: 5502,
        name: '妇科'
    }, {
        id: 5501,
        name: '外科'
    }, {
        id: 5500,
        name: '内科'
    }]
}]

export const pharmacySubjectItemList = [{
    subjectId: 1,
    list: [{
        id: 5513,
        name: '基础知识'
    }, {
        id: 5536,
        name: '相关专业知识'
    },{
        id: 5537,
        name: '专业知识'
    }, {
        id: 5538,
        name: '专业实践能力'
    }]
}, {
    subjectId: 2,
    list: [{
        id: 5512,
        name: '基础知识'
    }, {
        id: 5546,
        name: '相关专业知识'
    }, {
        id: 5541,
        name: '专业知识'
    }, {
        id: 5543,
        name: '专业实践能力'
    }]
}, {
    subjectId: 3,
    list: [{
        id: 5514,
        name: '基础知识'
    }, {
        id: 5531,
        name: '相关专业知识'
    }, {
        id: 5532,
        name: '专业知识'
    }, {
        id: 5542,
        name: '专业实践能力'
    }]
}, {
    subjectId: 4,
    list: [{
        id: 5523,
        name: '基础知识'
    }, {
        id: 5540,
        name: '相关专业知识'
    }, {
        id: 5541,
        name: '专业知识'
    }, {
        id: 5543,
        name: '专业实践能力'
    }]
}, {
    subjectId: 5,
    list: [{
        id: 5515,
        name: '基础知识'
    }, {
        id: 5534,
        name: '相关专业知识'
    }, {
        id: 5533,
        name: '专业知识'
    }, {
        id: 5530,
        name: '专业实践能力'
    }]
},{
    subjectId: 6,
    list: [{
        id: 5524,
        name: '基础知识'
    }, {
        id: 5527,
        name: '相关专业知识'
    }, {
        id: 5535,
        name: '专业知识'
    }, {
        id: 5539,
        name: '专业实践能力'
    }]
}]

export const architectSubjectItemList = [{
    subjectId: 1,
    list: [{
        id: 5552,
        name: '一建经济'
    }, {
        id: 5551,
        name: '一建法规'
    }, {
        id: 5548,
        name: '一建项目管理'
    }, {
        id: 5555,
        name: '一建建筑'
    }, {
        id: 5549,
        name: '一建市政'
    }, {
        id: 5550,
        name: '一建机电'
    }, {
        id: 5553,
        name: '一建公路'
    }, {
        id: 5554,
        name: '一建水利'
    }]
}, {
    subjectId: 2,
    list: []
}]

export default {
    formatTime,
    formatDate,
    getParamsFromStr,
    formatSeconds,
    validateMobile,
    filterTextByObj,
    autoPlayVideo,
    findBrothersComponents,
    format,
    nurseSubjectItemList,
    pharmacySubjectItemList,
    architectSubjectItemList
}


// WEBPACK FOOTER //
// ./src/utils/util.js